/**
 * Adapted from disgusting-dev @ https://gist.github.com/disgusting-dev/8d45aebff8a536af1cba39b0fcd203e3
 */
const events = ["click"];

function onClickOutside({ event, el, handler, middleware }) {
  const isClickOutside = event.target !== el && !el.contains(event.target);

  if (!isClickOutside || !middleware(event, el)) {
    return null;
  }

  return handler(event, el);
}

// this is allowed, becuase our logic does not actually run on the server
const instances = new Map();

//Requires loop to toggle events for several listeners of an element
function toggleEventListeners(eventHandlers) {
  return (action) => {
    if (!eventHandlers) {
      return;
    }
    eventHandlers.forEach(({ event, handler }) => {
      document[`${action}EventListener`](event, handler, true);
    });
  };
}

//Validator function
function processArgs(value) {
  const isFunction = typeof value === "function";

  if (!isFunction && typeof value !== "object") {
    error(
      `v-click-outside: Binding value should be a function or an object, ${typeof bindingValue} given`
    );
  }

  return {
    handler: isFunction ? value : value.handler,
    middleware: value.middleware || (() => true),
  };
}

//Now need adapter to handle several events for one Map element
function eventAdapter(events, { el, handler, middleware }) {
  return events.map((eventName) => ({
    event: eventName,
    handler: (event) => onClickOutside({ event, el, handler, middleware }),
  }));
}

function mounted(el, { value }) {
  if (utilities.isSSR()) {
    return;
  }
  const { handler, middleware } = processArgs(value);
  const eventHandlers = eventAdapter(events, { el, handler, middleware });

  instances.set(el, eventHandlers);

  toggleEventListeners(eventHandlers)("add");
}

function beforeUnmount(el) {
  if (utilities.isSSR()) {
    return;
  }

  const eventHandlers = instances.get(el);

  if (!eventHandlers) {
    try {
      instances.delete(el);
    } catch (e) {}
    return;
  }
  toggleEventListeners(eventHandlers)("remove");

  instances.delete(el);
}

const directive = {
  mounted,
  beforeUnmount,
};

export default directive;
